import React, { useEffect, useRef, useState } from "react";
import classNames from "classnames";
import styles from "./index.module.css";
import { Thumbnail } from "../../components/Thumbnail";

export default function ImageUpload({ content, onFileChange, children }) {
  const thumbnail = useRef(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [fileError, setFileError] = useState("");

  useEffect(() => {
    if (selectedFile) {
      const url = URL.createObjectURL(selectedFile);
      setPreview(url);
      onFileChange(selectedFile);

      return () => URL.revokeObjectURL(url);
    } else {
      setPreview(null);
    }
  }, [selectedFile]);

  function onSelectFile(e) {
    if (!e.target.files || e.target.files.length === 0) {
      return;
    }

    const file = e.target.files[0];
    if (!file.type.startsWith("image/")) {
      setFileError("Select an image file for the thumbnail.");
      e.target.value = "";
      return;
    }

    setFileError("");
    setSelectedFile(file);
  }

  function onClick() {
    thumbnail.current.click();
  }

  return (
    <div className={classNames(styles.container, styles.row)}>
      <Thumbnail
        src={preview || content.thumbnail}
        onClick={onClick}
        alt={"thumbnail"}
      />

      <div className={styles.button} onClick={onClick}>
        {children}
        {fileError && (
          <span
            className={styles.fileError}
            role="alert"
            onClick={(e) => e.stopPropagation()}
          >
            {fileError}
          </span>
        )}
      </div>

      <input
        type="file"
        id="thumbnail"
        ref={thumbnail}
        className={styles.file}
        accept="image/*"
        onChange={onSelectFile}
      />
    </div>
  );
}

ImageUpload.propTypes = {};
